(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 1200px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  class MenuDrawer extends HTMLElement {
    constructor() {
      super();
      this.mainDetailsToggle = this.querySelector('details');
      this.bindEvents();
    }

    bindEvents() {
      this.querySelectorAll('summary').forEach((summary) =>
        summary.addEventListener('click', this.onSummaryClick.bind(this))
      );
      this.querySelectorAll('button.menu-drawer__close-button, button.mobile-facets__close-button').forEach((button) =>
        button.addEventListener('click', this.onCloseButtonClick.bind(this))
      );
      this.querySelectorAll('[data-mega-toggle]').forEach((toggle) =>
        toggle.addEventListener('click', this.onMegaToggleClick.bind(this))
      );
    }

    onMegaToggleClick(event) {
      const toggle = event.currentTarget;
      const expanded = toggle.getAttribute('aria-expanded') === 'true';

      if (expanded) {
        toggle.setAttribute('aria-expanded', 'false');
        const content = toggle.closest('.menu-drawer__mega-trigger-row').nextElementSibling;
        if (content && content.matches('[data-mega-content]')) {
          content.hidden = true;
        }
        return;
      }

      this.querySelectorAll('[data-mega-toggle][aria-expanded="true"]').forEach((other) => {
        other.setAttribute('aria-expanded', 'false');
        const otherContent = other.closest('.menu-drawer__mega-trigger-row').nextElementSibling;
        if (otherContent && otherContent.matches('[data-mega-content]')) {
          otherContent.hidden = true;
        }
      });

      toggle.setAttribute('aria-expanded', 'true');
      const content = toggle.closest('.menu-drawer__mega-trigger-row').nextElementSibling;
      if (content && content.matches('[data-mega-content]')) {
        content.hidden = false;
      }
    }

    onSummaryClick(event) {
      const summaryElement = event.currentTarget;
      const detailsElement = summaryElement.parentNode;
      const parentMenuElement = detailsElement.closest('.has-submenu');
      const isOpen = detailsElement.hasAttribute('open');

      if (detailsElement === this.mainDetailsToggle) {
        if (isOpen) event.preventDefault();
        isOpen ? this.closeMenuDrawer(event, summaryElement) : this.openMenuDrawer(summaryElement);
      } else {
        // Filter submenus are absolutely positioned at the top of the filter
        // list's scroll area, so scroll it back to the top (remembering where
        // the user was for when they come back) or the submenu opens hidden
        // under the drawer header.
        if (parentMenuElement && parentMenuElement.classList.contains('mobile-facets__main') && !isOpen) {
          parentMenuElement.dataset.scrollTop = parentMenuElement.scrollTop;
          parentMenuElement.scrollTop = 0;
          const submenu = detailsElement.querySelector('.mobile-facets__submenu');
          if (submenu) submenu.scrollTop = 0;
        }
        setTimeout(() => {
          detailsElement.classList.add('menu-opening');
          summaryElement.setAttribute('aria-expanded', true);
          parentMenuElement && parentMenuElement.classList.add('submenu-open');
        }, 100);
      }
    }

    openMenuDrawer(summaryElement) {
      setTimeout(() => {
        this.mainDetailsToggle.classList.add('menu-opening');
      });
      summaryElement.setAttribute('aria-expanded', true);
      document.body.classList.add(`overflow-hidden-${this.dataset.breakpoint}`);
    }

    closeMenuDrawer(event, elementToFocus = false) {
      if (event === undefined) return;
      this.mainDetailsToggle.classList.remove('menu-opening');
      this.mainDetailsToggle.querySelectorAll('details').forEach((details) => {
        details.removeAttribute('open');
        details.classList.remove('menu-opening');
      });
      this.mainDetailsToggle.querySelectorAll('.submenu-open').forEach((submenu) => {
        submenu.classList.remove('submenu-open');
      });
      this.mainDetailsToggle.querySelectorAll('summary[aria-expanded="true"]').forEach((summary) => {
        summary.setAttribute('aria-expanded', 'false');
      });
      const mainSummary = this.mainDetailsToggle.querySelector(':scope > summary');
      mainSummary && mainSummary.setAttribute('aria-expanded', 'false');
      document.body.classList.remove(`overflow-hidden-${this.dataset.breakpoint}`);
      this.closeAnimation(this.mainDetailsToggle);
    }

    onCloseButtonClick(event) {
      const detailsElement = event.currentTarget.closest('details');
      this.closeSubmenu(detailsElement);
    }

    closeSubmenu(detailsElement) {
      const parentMenuElement = detailsElement.closest('.submenu-open');
      parentMenuElement && parentMenuElement.classList.remove('submenu-open');
      if (parentMenuElement && parentMenuElement.dataset.scrollTop) {
        const scrollTop = parentMenuElement.dataset.scrollTop;
        delete parentMenuElement.dataset.scrollTop;
        // Wait for the submenu to finish sliding out; it moves with main's scroll.
        setTimeout(() => (parentMenuElement.scrollTop = scrollTop), 400);
      }
      detailsElement.classList.remove('menu-opening');
      detailsElement.querySelector('summary').setAttribute('aria-expanded', false);
      this.closeAnimation(detailsElement);
    }

    closeAnimation(detailsElement) {
      let animationStart;
      const handleAnimation = (time) => {
        if (animationStart === undefined) animationStart = time;
        const elapsedTime = time - animationStart;
        if (elapsedTime < 400) {
          window.requestAnimationFrame(handleAnimation);
        } else {
          detailsElement.removeAttribute('open');
        }
      };
      window.requestAnimationFrame(handleAnimation);
    }
  }

  customElements.define('menu-drawer', MenuDrawer);

  class HeaderDrawer extends MenuDrawer {
    constructor() {
      super();
    }

    openMenuDrawer(summaryElement) {
      this.header = this.header || document.querySelector('.section-header');
      this.borderOffset =
        this.borderOffset ||
        (this.closest('.header-wrapper').classList.contains('header-wrapper--border-bottom') ? 1 : 0);
      document.documentElement.style.setProperty(
        '--header-bottom-position',
        `${parseInt(this.header.getBoundingClientRect().bottom - this.borderOffset)}px`
      );
      document.documentElement.style.setProperty('--viewport-height', `${window.innerHeight}px`);
      this.header.classList.add('menu-open');
      setTimeout(() => {
        this.mainDetailsToggle.classList.add('menu-opening');
      });
      summaryElement.setAttribute('aria-expanded', true);
      document.body.classList.add(`overflow-hidden-${this.dataset.breakpoint}`);
    }

    closeMenuDrawer(event, elementToFocus) {
      if (!elementToFocus) return;
      super.closeMenuDrawer(event, elementToFocus);
      this.header && this.header.classList.remove('menu-open');
    }
  }

  customElements.define('header-drawer', HeaderDrawer);

  function initHeaderNavWrapWatcher() {
    var header = document.querySelector('.section-header .header');
    if (!header) return;
    var menus = header.querySelectorAll('.header__inline-menu');
    if (!menus.length) return;
    var desktopQuery = window.matchMedia('(min-width: 1200px)');

    function menuIsWrapped(nav) {
      var items = nav.querySelectorAll(':scope > ul > li');
      if (items.length < 2) return false;
      var firstTop = items[0].offsetTop;
      for (var i = 1; i < items.length; i++) {
        if (Math.abs(items[i].offsetTop - firstTop) > 2) return true;
      }
      return false;
    }

    function check() {
      header.classList.remove('header--nav-wrapped');
      if (!desktopQuery.matches) return;
      // Force a layout read with the inline menu visible before measuring,
      // since removing the class above may not have flushed layout yet.
      void header.offsetHeight;
      for (var i = 0; i < menus.length; i++) {
        if (menuIsWrapped(menus[i])) {
          header.classList.add('header--nav-wrapped');
          break;
        }
      }
    }

    var raf = null;
    function scheduleCheck() {
      if (raf) window.cancelAnimationFrame(raf);
      raf = window.requestAnimationFrame(check);
    }

    window.addEventListener('resize', scheduleCheck);
    window.addEventListener('load', scheduleCheck);
    if (window.document.fonts && window.document.fonts.ready) {
      window.document.fonts.ready.then(scheduleCheck);
    }
    scheduleCheck();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initHeaderNavWrapWatcher);
  } else {
    initHeaderNavWrapWatcher();
  }

  } catch(e) { console.error(e); }
})();
})();
